<template>
  <div class="line-items-header px-i">
    <Actions />

    <div class="line-items-header-currency-selector flex-grow-1 flex-sm-grow-0">
      <select v-model="selectedCurrencyId"
              name="invoice[currency_id]"
              class="custom-select custom-input"
              @change="onCurrencyChange($event)">
        <option
          v-for="currency in currencies"
          :key="currency.id"
          :value="currency.id">{{ currency.iso_code }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import Actions from "./Actions.vue";

export default {
  components: {
    Actions
  },

  props: {
    currencyId: { type: Number }
  },

  computed: {
    ...mapFields("lineItems", [
      "selectedCurrencyId"
    ]),

    ...mapFields("instruments", [
      "currencies"
    ])
  },

  created () {
    this.selectedCurrencyId = this.currencyId;
  },

  methods: {
    onCurrencyChange (event) {
      this.$emit("currencyChange", event);
    }
  }
};
</script>
